//Show variant description on variant change
document.addEventListener('on:variant:change', (event) => {
  // console.log(event);
  // console.log(event.detail);
  // console.log(event.detail.variant); 
  const elements = document.querySelectorAll('.variant_desc');

  elements.forEach((element) => {
    element.classList.add('hide');
  });

  if( typeof event.detail.variant === 'undefined' || event.detail.variant === null ) return;
  
  let variant_ID = "variant-"+ event.detail.variant.id;
  //console.log(variant_ID);
  const selectedVariant = document.getElementById(variant_ID);
  //console.log(selectedVariant);
  selectedVariant.classList.remove("hide");
});

//show variant description on page load
window.onload = function() {
  // Some code
  const urlParams = new URLSearchParams(window.location.search);
  const variantID = urlParams.get('variant');
  //console.log(variantID);

  let variant_ID = "variant-"+ variantID;
  const selectedVariant = document.getElementById(variant_ID);
  selectedVariant.classList.remove("hide");
};